import { buildingStorage } from '../shared/townhall'
import { RESOURCES, type Building } from '../shared/types'

export interface StorageStatus {
  used: number
  capacity: number
  remaining: number
  full: boolean
  level: 'normal' | 'near' | 'critical'
}

/** One hub's shared space, including soil/sand and Town Hall upgrade bonuses. */
export function storageStatus(b: Pick<Building, 'type' | 'hallPhase' | 'store'>): StorageStatus {
  const capacity = buildingStorage(b)
  const used = RESOURCES.reduce((sum, res) => sum + (b.store?.[res] ?? 0), 0)
  const remaining = Math.max(0, capacity - used)
  return {
    used, capacity, remaining,
    full: capacity > 0 && remaining < 1e-6,
    level: capacity <= 0 ? 'normal' : used >= capacity * 0.95 ? 'critical' : used >= capacity * 0.8 ? 'near' : 'normal',
  }
}
